import { render, staticRenderFns } from "./EventBannerSidebar.vue?vue&type=template&id=01de6152&"
import script from "./EventBannerSidebar.vue?vue&type=script&lang=js&"
export * from "./EventBannerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01de6152')) {
      api.createRecord('01de6152', component.options)
    } else {
      api.reload('01de6152', component.options)
    }
    module.hot.accept("./EventBannerSidebar.vue?vue&type=template&id=01de6152&", function () {
      api.rerender('01de6152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/event/components/EventBannerSidebar.vue"
export default component.exports